// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"555":"f35a72d9","976":"9e2bb725"}[chunkId] + ".chunk.js";
};